import multiApiClient from "./base";

export const ShopifyApi = {
  createMarginRule: (rule) =>
    multiApiClient.post("/shopify/margin-rules", rule),
  getMarginRules: () => multiApiClient.get("/shopify/margin-rules"),
  getMarginRule: (ruleId) =>
    multiApiClient.get(`/shopify/margin-rules/${ruleId}`),
  updateMarginRule: (ruleId, rule) =>
    multiApiClient.put(`/shopify/margin-rules/${ruleId}`, rule),
  deleteMarginRule: (ruleId) =>
    multiApiClient.delete(`/shopify/margin-rules/${ruleId}`),
};

export const ShopifyArticlesApi = {
  // Cron
  startCronJob: (schedule = "0 8 * * *") =>
    multiApiClient.post("/shopify/articles/cron/start", null, {
      params: { schedule },
    }),

  stopCronJob: () => multiApiClient.post("/shopify/articles/cron/stop"),

  getCronStatus: () => multiApiClient.get("/shopify/articles/cron/status"),

  // Recalculate
  recalculate: (sku) =>
    multiApiClient.post(
      `/shopify/articles/recalculate/${encodeURIComponent(sku)}`,
    ),

  // Export updated prices to Plenty/Shopify
  exportUpdates: (sku = null) =>
    multiApiClient.post("/shopify/articles/export-updates", null, {
      params: sku ? { sku } : {},
    }),
};
